export default __webpack_public_path__ + "6c4560e9469ecd5299b75189a38335e5.png";